import { BROADCAST_SET_MEDIA_PLAYER_SETTINGS } from 'actions/Types';

const initialState = {};

function mediaPlayerSettings(state = initialState, action) {
  if (action.type === `${BROADCAST_SET_MEDIA_PLAYER_SETTINGS}`) {
    return action.payload;
  }

  return state;
}

export default mediaPlayerSettings;
